<template>
  <div class="md-layout">
    <div id="promo_manage" class="mktops-maincontent-manage">
      <div :class="loadData || loadsearch ? 'bg-backdrop' : ''"></div>
      <div
        style="position: absolute; top: 50%; left: 50%; width: 10%; z-index: 7"
        v-show="loadData || loadsearch"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>

      <div
        :class="
          checkExpand
            ? 'md-gutter left-panel -display-100'
            : 'md-gutter left-panel'
        "
      >
        <label class="head-title-page">MANAGE MY PROMOTIONS</label>
        <md-card v-show="!checkExpand" class="main-content">
          <div class="md-layout mktops-select-box">
            <div class="mktops-subheader-filter">
              <md-field class="box">
                <md-select class="status-type" v-model="slcStatus">
                  <md-option
                    class="latofont"
                    v-for="(item, index) in status"
                    :key="index"
                    v-bind:value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>
              <md-field class="box ml-10">
                <md-select v-model="slcDuration">
                  <md-option
                    class="latofont"
                    v-for="(items, indexs) in vDuration"
                    :key="indexs"
                    v-bind:value="items"
                    >{{ items }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
            <div
              class="mktops-subheader-text"
              style="display: flex; justify-content: flex-end; padding-top: 6px"
            >
              <md-button
                class="md-icon-button"
                style="
                  width: 25px;
                  min-width: 25px;
                  height: 25px;
                  margin-left: 0px;
                  margin-right: 3px;
                "
                @click="showDialogFilterSearch()"
              >
                <md-icon title="Add Filters">filter_list</md-icon>
              </md-button>

              <md-button
                class="md-icon-button"
                style="
                  width: 25px;
                  min-width: 25px;
                  height: 25px;
                  margin-right: 0px;
                "
                @click="searchPromotion()"
              >
                <md-icon title="Search" style="padding-top: 2px; color: #3f51b5"
                  >search</md-icon
                >
              </md-button>
            </div>
          </div>

          <div class="md-layout">
            <md-field class="md-search-box">
              <i class="md-icon material-icons">search</i>
              <md-input
                type="text"
                v-model="iptSearch"
                placeholder="Search my promotions…"
              ></md-input>
            </md-field>
          </div>

          <div class="md-layout filter-chips" v-if="filterChips.length > 0">
            <div v-for="(items, idx) in filterChips" :key="items.keyId">
              <div v-show="idx == 0 || idx == 1">
                <span class="tab-chip -primary" :title="items.name">
                  {{ countString(items) }}
                  <span
                    class="tab-chip -delete"
                    @click="deleteFilter(items, idx)"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>
              </div>
              <div v-show="idx == 2" style="margin-top: 8px">
                <span class="tab-chip -primary" :title="items.name">
                  {{ countString(items) }}
                  <span
                    class="tab-chip -delete"
                    @click="deleteFilter(items, idx)"
                  >
                    <i class="material-icons">close</i>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div :class="displayHeight()">
            <div class="mktops-label-nodata" v-if="promotions.length == 0">
              No promotions to display
            </div>
            <div
              class="mktops-promo-box-list"
              v-else
              v-for="(item, index) in promotions"
              :key="index"
            >
              <div class="mktops-circle-green kanitfont">
                {{ textCircle(item.promotion_title) }}
              </div>
              <div class="mktops-promo-list-name" @click="checkProduct(item)">
                <div
                  class="title-list"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item.promotion_code }}
                </div>
                <div class="subtitle-list kanitfont">
                  {{ item.promotion_title }}
                </div>
              </div>
              <div style="width: 25%; margin-left: 5px">
                <div
                  style="
                    font-size: 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                    color: rgba(0, 0, 0, 0.38);
                    font-weight: 600;
                  "
                >
                  {{ item.create_firstname }}
                </div>
                <div style="display: flex">
                  <div :class="randerStatus(item)">
                    {{
                      item.type_active && item.type == "Draft"
                        ? "Inactive"
                        : item.type.charAt(0).toUpperCase() + item.type.slice(1)
                    }}
                  </div>
                  <div>
                    <md-menu md-align-trigger>
                      <md-button
                        class="md-icon-button"
                        md-menu-trigger
                        style="margin-top: 0px"
                      >
                        <md-icon
                          style="font-size: 20px !important; margin-bottom: 8px"
                          >more_vert</md-icon
                        >
                      </md-button>
                      <md-menu-content v-if="item.c_user == getUserDB.code">
                        <div
                          v-for="rows in $store.getters[
                            'pmmanage/mng_condition_list'
                          ]"
                          :key="rows.id"
                        >
                          <div v-if="item.type == 'Pending'">
                            <template
                              v-if="
                                rows.name != 'Edit' && rows.name != 'Delete'
                              "
                            >
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Track' &&
                                  (!item.tracking || item.tracking == 'false')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Cancel Tracking' &&
                                  (item.tracking || item.tracking == 'true')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="rows.name == 'Duplicate'"
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                            </template>
                          </div>
                          <div v-else-if="item.type == 'Active'">
                            <template v-if="rows.name != 'Delete'">
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Track' &&
                                  (!item.tracking || item.tracking == 'false')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Cancel Tracking' &&
                                  (item.tracking || item.tracking == 'true')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Duplicate' ||
                                  rows.name == 'Inactive Promo'
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                            </template>
                          </div>
                          <div
                            v-else-if="
                              (item.type_active == true &&
                                item.type == 'Draft') ||
                              item.type == 'Return'
                            "
                          >
                            <template v-if="rows.name != 'Delete'">
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Track' &&
                                  (!item.tracking || item.tracking == 'false')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Cancel Tracking' &&
                                  (item.tracking || item.tracking == 'true')
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                              <md-menu-item
                                class="latofont"
                                v-if="
                                  rows.name == 'Duplicate' ||
                                  rows.name == 'Edit'
                                "
                                @click="selectedCondition(index, item, rows)"
                              >
                                {{ rows.name }}
                              </md-menu-item>
                            </template>
                          </div>
                          <div v-else>
                            <md-menu-item
                              class="latofont"
                              v-if="
                                rows.name == 'Track' &&
                                (!item.tracking || item.tracking == 'false')
                              "
                              @click="selectedCondition(index, item, rows)"
                            >
                              {{ rows.name }}
                            </md-menu-item>
                            <md-menu-item
                              class="latofont"
                              v-if="
                                rows.name == 'Cancel Tracking' &&
                                (item.tracking || item.tracking == 'true')
                              "
                              @click="selectedCondition(index, item, rows)"
                            >
                              {{ rows.name }}
                            </md-menu-item>
                            <md-menu-item
                              class="latofont"
                              v-if="
                                rows.name == 'Duplicate' ||
                                rows.name == 'Edit' ||
                                rows.name == 'Delete'
                              "
                              @click="selectedCondition(index, item, rows)"
                            >
                              {{ rows.name }}
                            </md-menu-item>
                          </div>
                        </div>
                      </md-menu-content>
                      <md-menu-content v-else>
                        <div
                          v-for="rows in $store.getters[
                            'pmmanage/mng_condition_list'
                          ]"
                          :key="rows.id"
                        >
                          <md-menu-item
                            class="latofont"
                            v-if="
                              rows.name == 'Track' &&
                              (!item.tracking || item.tracking == 'false')
                            "
                            @click="selectedCondition(index, item, rows)"
                          >
                            {{ rows.name }}
                          </md-menu-item>
                          <md-menu-item
                            class="latofont"
                            v-if="
                              rows.name == 'Cancel Tracking' &&
                              (item.tracking || item.tracking == 'true')
                            "
                            @click="selectedCondition(index, item, rows)"
                          >
                            {{ rows.name }}
                          </md-menu-item>
                          <md-menu-item
                            class="latofont"
                            v-if="rows.name == 'Duplicate'"
                            @click="selectedCondition(index, item, rows)"
                          >
                            {{ rows.name }}
                          </md-menu-item>
                        </div>
                      </md-menu-content>
                    </md-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-table">
            number of lines in page ({{ promotions.length }})
          </div>
        </md-card>
      </div>

      <!--Right Panel-->
      <div
        :class="
          checkExpand
            ? 'md-layout-item right-panel -displaynone'
            : 'md-layout-item right-panel'
        "
      >
        <div style="text-align: right; margin-bottom: 12px; margin-right: 10px">
          <md-menu
            md-size="huge"
            :md-offset-y="12"
            style="display: flex; justify-content: flex-end"
          >
            <span class="noti-chip-red">{{ countNotification }}</span>
            <div>
              <md-icon
                style="color: #3f51b5; cursor: pointer"
                md-menu-trigger
                title="Notifications"
                >notifications</md-icon
              >
            </div>
            <md-menu-content class="promo-content-noti">
              <div class="title">Notifications</div>
              <div class="detais">
                <div
                  v-for="(item, index) in dataNotification"
                  :key="index"
                  @click="$store.commit('pmmanage/openApvDialog', item)"
                >
                  <md-menu-item class="item-card">
                    <div :title="item.promotion_title">
                      <div style="color: rgba(57, 139, 237, 1)">
                        {{ item.promotion_code }}
                      </div>
                      <div style="width: 100%; display: flex; margin-top: 6px">
                        <div style="width: 70%" class="nowrap-title">
                          {{ item.promotion_title }}
                        </div>
                        <div style="width: 30%" class="noti-date">
                          {{ convertDate(item.u_time) }}
                        </div>
                      </div>
                    </div>
                  </md-menu-item>
                </div>
              </div>
            </md-menu-content>
          </md-menu>
        </div>

        <md-card class="promotion-calendar-card main-content">
          <md-card-header>
            <div class="md-layout">
              <div class="group-mktops-label">
                <label class="mktops-subheader-text">Calendar View</label>
              </div>
              <div class="group-mktops-label-btn">
                <div
                  class="mktops-label-btn green"
                  @click="toggleHeight('increase_sales')"
                  :class="
                    increase_sales
                      ? 'mktops-label-btn green'
                      : 'mktops-label-btn gray'
                  "
                >
                  Increase Sales
                </div>
                <div
                  class="mktops-label-btn sky"
                  @click="toggleHeight('increase_outlet')"
                  :class="
                    increase_outlet
                      ? 'mktops-label-btn green'
                      : 'mktops-label-btn gray'
                  "
                >
                  Increase Outlet
                </div>
                <div
                  class="mktops-label-btn blue"
                  @click="toggleHeight('new_product')"
                  :class="
                    new_product
                      ? 'mktops-label-btn green'
                      : 'mktops-label-btn gray'
                  "
                >
                  New Product
                </div>
                <div
                  class="mktops-label-btn violet"
                  @click="toggleHeight('compete')"
                  :class="
                    compete ? 'mktops-label-btn green' : 'mktops-label-btn gray'
                  "
                >
                  Compete
                </div>
                <div class="ml-10 mktops-select-box">
                  <md-field class="box">
                    <md-select
                      v-model="viewMonth"
                      @md-selected="changeViewMonth"
                    >
                      <md-option
                        class="latofont"
                        v-for="items in mng_month_list"
                        :key="items.id"
                        v-bind:value="items.id"
                        >{{ items.name }}</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <Calendar
              ref="calendar"
              :viewMonth="viewMonth"
              :eventData="eventsData"
              :checkChange="checkChange"
              v-on:clickEvent="viewCampaign"
            ></Calendar>
          </md-card-content>
        </md-card>
      </div>

      <md-dialog
        :md-active.sync="showFilterDialog"
        class="filter-dialog"
        style="height: 380px"
        :md-click-outside-to-close="false"
      >
        <md-dialog-title>Add Filters</md-dialog-title>
        <div class="layout-dialog">
          <div style="font-size: 12px; color: #727272; padding-left: 5px">
            Filter by Product or Product Group
          </div>
          <div style="width: 100%">
            <search-box-dropdown
              :show="showFilterDialog"
              :typeSearch="true"
              :menuSelected="'manage'"
              :valueInput="valueProductGroup"
              @addproduct="addProduct"
            ></search-box-dropdown>
          </div>

          <!-- <multiselect
            v-model="filterProductGroup"
            label="label"
            track-by="id"
            :placeholder="'Search Product or Product Group'"
            :options="productGroups"
            :searchable="true"
            :max-height="225"
            :show-no-results="false"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
            :custom-label="customLabel"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div class="-label">{{ option.id }} - {{ option.label }}</div>
                <div
                  class="-delete"
                  @mousedown.prevent.stop="clearAll(option.id, 'product')"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect> -->

          <div
            style="
              font-size: 12px;
              color: #727272;
              padding-left: 5px;
              margin-top: 12px;
            "
          >
            Filter by Customer Group
          </div>
          <multiselect
            v-model="filterCustGroup"
            label="group_name"
            track-by="group_name"
            :placeholder="'Search Customer Group'"
            :options="customerGroups"
            :searchable="true"
            :max-height="150"
            :show-no-results="false"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div class="-label">{{ option.group_name }}</div>
                <div
                  class="-delete"
                  @mousedown.prevent.stop="clearAll(option.id, 'customer')"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect>

          <div style="font-size: 12px; color: #727272; padding-left: 5px">
            Filter by User Create
          </div>
          <multiselect
            v-model="filterUserCreate"
            label="name"
            track-by="code"
            :placeholder="'Search User Create'"
            :open-direction="'top'"
            :options="optionUserCreate"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div class="-label">{{ option.name }}</div>
                <div
                  class="-delete"
                  @mousedown.prevent.stop="clearAll(option.id, 'usercreate')"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect>
        </div>

        <md-dialog-actions class="-action">
          <md-button @click="closeFilterDialog" class="md-cancel"
            >cancel</md-button
          >
          <md-button class="md-primary" @click="addCondFilter"
            >add filter</md-button
          >
        </md-dialog-actions>
      </md-dialog>
      <ApproveDialog></ApproveDialog>
    </div>

    <md-dialog-confirm
      :md-active.sync="dialog.active"
      md-title="Confirm?"
      :md-content="dialog.content"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-dialog-confirm
      :md-active.sync="dialogActivePromo"
      md-title="Confirm"
      md-content="Are you sure to inactive ?"
      md-confirm-text="Sure"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirmInAvtivePromo"
    />

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
    </md-snackbar>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import CalendarView from "./manage/calendar";
import Multiselect from "vue-multiselect";
// import Calendar from "./manage/calendar-view";
import infiniteScroll from "vue-infinite-scroll";
import ApproveDialog from "./manage/apv-view-dialog";
import CipherService from "@/services/cipher";
import promotionService from "@/services/promotion";
import moment from "moment-timezone";
import Vue from "vue";
import router from "@/router";
import _ from "lodash";
import { constants } from "crypto";
import { close } from "fs";
import searchBoxDropdown from "@/components/shared/search-box-dropdown";

export default {
  name: "promotion-manage",
  created() {
    this.$store.commit("pmmanage/loadingPage", true);
    this.$store.commit("pmmanage/setPromotions", []);
    this.$store.commit("pmmanage/setPromotionsAll", []);
    this.$store.dispatch("pmmanage/getUserDB");
    this.$store.dispatch("pmmanage/getPromotions");
    this.$store.commit("pmmanage/firstTime", true);

    this.$store.commit("pmmanage/closeApvDialog");
    var x = document.getElementsByTagName("body");
    x[0].setAttribute("style", "overflow-x: hidden;");
    // this.$store.dispatch("pmmanage/getPromotions");

    /*--- START Check ตามสิทธิการมองเห็นของ Promotion ---*/
    let user = this.$jwt.decode(localStorage.getItem("token"));
    promotionService.getPromotions(user.code, "all").then((rs) => {
      if (rs.length > 0) {
        // this.createUserFilterByPromo.push(...rs);
        const filteredPromotions = rs.filter(userpromo => userpromo.name !== "" && userpromo.name !== null);
        if (filteredPromotions.length > 0) {
          this.createUserFilterByPromo.push(...filteredPromotions);
        }
      }
      /*for (let i = 0; i < rs.length; i++) {
          let key = this.createUserFilterByPromo.findIndex((item) => {
            return item.code === rs[i].c_user;
          });
          if (key === -1) {
            this.createUserFilterByPromo.push({
              code: rs[i].c_user,
              name: rs[i].displayname,
            });
          }
        }*/
        const uniqueUsers = this.createUserFilterByPromo.filter((user, index, self) => 
            index === self.findIndex((u) => u.code === user.code)
        );
        this.createUserFilterByPromo = [...uniqueUsers];

      //  console.log("this.createUserFilterByPromo ==>", this.createUserFilterByPromo);
    });
    /*--- END Check ตามสิทธิการมองเห็นของ Promotion ---*/
    /*
    let user = this.$jwt.decode(localStorage.getItem("token"));
    CipherService.getBossCode(user.code)
      .then((response) => {
        user = {
          code: user.code,
          boss_code:
            response.resource.length > 0 ? response.resource[0].boss_code : "",
        };

        promotionService.getUserUnderPromortion(user.boss_code).then((rs) => {
          this.optionUserCreate = [];
          for (let i = 0; i < rs.length; i++) {
            this.optionUserCreate.push({
              code: rs[i]["code"],
              name: rs[i]["firstname_en"].toUpperCase(),
            });
          }
          this.optionUserCreate.sort((a, b) => (a.name > b.name ? 1 : -1));

          this.filterUserCreate = {
            code: user.code,
            name: user.username.toUpperCase(),
          };
          this.filterChips.push({
            name: user.username.toUpperCase(),
            type: "usercreate",
          });

          // this.searchPromotion();
        });
      })
      .catch((error) => console.log(error));
      */

    // let user = Vue.$jwt.decode(localStorage.getItem("token"));
    // console.log("user ==>",user);
    promotionService
      .getFilterUsercreatePromortion({
        code: user.code,
        boss_code: user.boss_code,
        group: user.group,
      })
      .then((rs) => {
        this.optionUserCreate = [];
        for (let i = 0; i < rs.length; i++) {
          /*--- START Check ตามสิทธิการมองเห็นของ Promotion ด้านบน ---*/
          this.optionUserCreate = this.createUserFilterByPromo;
          let key = this.createUserFilterByPromo.findIndex((item) => {
            return item.code === rs[i].code;
          });
          if (key === -1) {
            this.optionUserCreate.push({
              code: rs[i]["code"],
              name: rs[i]["displayname"],
            });
          }
          /*--- END Check ตามสิทธิการมองเห็นของ Promotion ด้านบน ---*/

          // this.optionUserCreate.push({
          //   code: rs[i]["code"],
          //   name: rs[i]["displayname"],
          // });
        }

        if (user.group === "Manager" || user.code === "361011") {
          let key = this.optionUserCreate.findIndex((item) => {
            return item.code === user.code;
          });
          if (key === -1) {
            this.optionUserCreate.unshift({
              code: user.code,
              name: user.firstname + " " + user.lastname,
            });
          }
        }
        this.optionUserCreate.sort((a, b) => (a.name > b.name ? 1 : -1));

        this.filterUserCreate = this.optionUserCreate.find(
          (option) => option.code === user.code
        );
        this.filterChips.push({
          name: this.filterUserCreate.name,
          type: "usercreate",
        });
      });
    /*
    promotionService.getUserUnderPromortion(user.boss_code).then((rs) => {
      this.optionUserCreate = [];
      for (let i = 0; i < rs.length; i++) {
        this.optionUserCreate.push({
          code: rs[i]["code"],
          name: rs[i]["displayname"],
          // name: rs[i]["firstname_en"].toUpperCase(),
        });
      }
      this.optionUserCreate.sort((a, b) => (a.name > b.name ? 1 : -1));

      // this.filterUserCreate = {
      //   code: user.code,
      //   name: user.username.toUpperCase(),
      // };
      this.filterUserCreate = this.optionUserCreate.find(
        (option) => option.code === user.code
      );
      this.filterChips.push({
        // name: user.username.toUpperCase(),
        name: this.filterUserCreate.name,
        type: "usercreate",
      });

      // this.searchPromotion();
    });
    */

    // this.searchPromotion("", "created");
  },
  mounted() {
    this.$store.dispatch("pmcreate/getCustomerGroups");
    // this.$store.dispatch("pmcreate/getProductGroups");
  },
  computed: {
    loadData() {
      return this.$store.getters["pmmanage/loadData"];
    },
    getUserDB() {
      return this.$store.getters["pmmanage/userdb"];
    },
    promotions() {
      let linkId = this.$route.params.id;
      let promotionOpen = "";
      let displayPromotions =
        this.$store.getters["pmmanage/display_promotions"];
      if (this.dataNotification.length == 0 || displayPromotions.length == 0) {
        // if(displayPromotions.length == 0) {
        let data = this.$store.getters["pmmanage/promotions"];
        this.$store.commit("pmmanage/setDisplayPromotions", data);
        let self = this;
        this.dataNotification = [];
        data.forEach(function (value) {
          if (
            (value.type == "Return" && self.getUserDB.code == value.c_user) ||
            (value.type == "Pending" &&
              self.getUserDB.code != value.c_user &&
              self.getUserDB.code == value.approve_by)
          ) {
            self.dataNotification.push(value);
          }
        });

        this.countNotification = this.dataNotification.length;
        this.dataNotification.sort((a, b) => (a.u_time > b.u_time ? 1 : -1));
      }

      // let check_first_time = this.$store.getters["pmmanage/first_time"];
      // console.log("- computed : promotions -");
      // this.searchPromotion("", "created");

      let data = this.$store.getters["pmmanage/promotions"];
      let self = this;
      self.eventsData = [];
      data.forEach(function (value) {
        self.eventsData.push({
          id: value._id,
          title: value.promotion_title,
          code: value.promotion_code,
          start: value.startdate,
          end: value.enddate,
          status: value.type,
          promotion_type: value.promotion_type,
          /*-- CHANGE 25.07.2019 OPL#62 --*/
          checkShow: true,
          create_firstname: value.create_firstname,
          // checkShow: value.promotion_type == "CP" ? false : true
        });
        if (value._id === linkId) {
          promotionOpen = value;
        }
      });
      if (promotionOpen !== "") {
        this.checkProduct(promotionOpen);
      }

      // this.searchPromotion('', 'promotions');

      // self.$store.commit("pmmanage/loadingPage", false);
      // let rspm = this.$store.getters["pmmanage/promotions"];
      // // console.log("rspm ==>", rspm);
      // this.optionUserCreate = [];
      // for (let i = 0; i < rspm.length; i++) {
      //   let index = this.optionUserCreate
      //     .map(function (e) {
      //       return e.code;
      //     })
      //     .indexOf(rspm[i]["c_user"]);
      //   if (index === -1) {
      //     this.optionUserCreate.push({
      //       code: rspm[i]["c_user"],
      //       name: rspm[i]["create_firstname"],
      //     });
      //   }
      // }
      // console.log("this.optionUserCreate ==>", this.optionUserCreate);
      // if (this.optionUserCreate.length > 0 && this.checkLoadFirst) {
      //   // console.log("***");
      //   let user = Vue.$jwt.decode(localStorage.getItem("token"));
      //   this.filterUserCreate = {
      //     code: user.code,
      //     name: user.username.toUpperCase(),
      //   };

      //   this.filterChips.push({
      //     name: user.username.toUpperCase(),
      //     type: "usercreate",
      //   });
      //   this.checkLoadFirst = false;
      // this.searchPromotion();
      // }

      return this.$store.getters["pmmanage/promotions"];
    },
    customerGroups() {
      return this.$store.getters["pmcreate/customer_groups"];
    },
    productGroups() {
      return this.$store.getters["pmcreate/product_groups"];
    },
    filterProduct() {
      return this.$store.getters["pmmanage/customer_groups"];
    },
  },
  components: {
    // Calendar,
    Calendar: CalendarView,
    Multiselect,
    ApproveDialog,
    searchBoxDropdown,
  },
  data() {
    return {
      // checkLoadFirst: true,
      createUserFilterByPromo: [],
      loadsearch: false,
      checkExpand: false,
      promoData: [],
      dialogActivePromo: false,
      countNotification: 0,
      dataNotification: [],
      index_dup_code: 0,
      copy_promo_code: "",
      showSnackbar: false,
      position: "center",
      duration: 3500,
      isInfinity: false,
      dContent: "",
      refreshPage: false,
      checkChange: false,
      viewMonth: 3,
      eventsData: [],
      titleChip: false,
      promotion: null,
      promotion_index: null,
      dialog: {
        active: false,
        content: "",
      },
      slcStatus: "All",
      slcDuration: "Present",
      slcStrategies: "1",
      slcMonth: "3",
      busy: false,
      iptSearch: "",
      increase_sales: true,
      increase_outlet: true,
      new_product: true,
      // compete: false,
      compete: true,
      // status: ["All", "Active", "Draft", "Pending"],
      status: ["All", "Draft", "Pending", "Return", "Active", "Inactive"],
      vDuration: ["Present", "Future", "Old"],
      mng_month_list: [
        {
          id: 3,
          name: "3-month",
        },
        {
          id: 6,
          name: "6-month",
        },
        {
          id: 12,
          name: "12-month",
        },
      ],
      showFilterDialog: false,
      filterProductGroup: [],
      valueProductGroup: {},
      filterCustGroup: [],
      filterUserCreate: [],
      tmpFilterProductGroup: [],
      tmpFilterCustGroup: [],
      tmpFilterUserCreate: [],
      optionUserCreate: [],
      arrProduct: [
        {
          name: "Product 0015555555555555555555555555555555555555555555555",
          id: 1,
        },
        {
          name: "Product 002",
          id: 2,
        },
        {
          name: "Product 003",
          id: 3,
        },
        {
          name: "Product 004",
          id: 4,
        },
        {
          name: "Product 005",
          id: 5,
        },
      ],
      arrCustomerGroup: [
        {
          name: "(1) ลูกค้าเขตกรุงเทพมหานค",
          id: 1,
        },
        {
          name: "(2) ลูกค้าเขตต่างจังหวัด",
          id: 2,
        },
        {
          name: "(3) Customer Group 3",
          id: 3,
        },
        {
          name: "(4) Customer Group 4",
          id: 4,
        },
        {
          name: "(5) Customer Group 4",
          id: 5,
        },
      ],
      filterChips: [],
      checkLoadDataServer: true,
      // placeholderPro: "Filter by Product or Product Group",
      // placeholderCust: "Filter by Customer Group",
      // placeholderUser: "Filter by User Create",
    };
  },
  watch: {
    // promotions(promos) {
    //   if(this.dataNotification.length == 0) {
    //     let data = promos;
    //     this.$store.commit("pmmanage/setDisplayPromotions", data);
    //     let self = this;
    //     this.dataNotification = [];
    //     data.forEach(function (value) {
    //         if((value.type == 'Return' && (self.getUserDB.code == value.c_user)) ||
    //           (value.type == 'Pending' && (self.getUserDB.code != value.c_user && self.getUserDB.code == value.approve_by))) {
    //             self.dataNotification.push(value);
    //         }
    //     });

    //     this.countNotification = this.dataNotification.length;
    //     this.dataNotification.sort((a, b) => (a.u_time > b.u_time) ? 1 : -1)
    //   }
    // },
    refreshPage() {
      return this.$store.getters["pmmanage/promotions"];
    },
    showFilterDialog: function () {
      this.$store.commit("pmmanage/closeApvDialog");
    },
    // iptSearch: function () {
    //   this.searchPromotion("", "iptSearch");
    // },
    // slcStatus: function () {
    //   this.searchPromotion("", "slcStatus");
    // },
    // slcStrategies: function () {
    //   this.searchPromotion("", "slcStrategies");
    // },
    // slcDuration: function () {
    //   this.searchPromotion("duration", "slcDuration");
    // },
  },
  methods: {
    displayHeight() {
      if (this.filterChips.length > 0 && this.filterChips.length < 3) {
        return "mktops-promo-box de-height";
      } else if (this.filterChips.length > 2) {
        return "mktops-promo-box de3-height";
      } else {
        return "mktops-promo-box cal-height";
      }
    },
    textCircle(title) {
      return title.substring(0, 5);
    },
    addProduct(item) {
      if (item === "") {
        this.filterProductGroup = {};
        this.valueProductGroup = {};
      } else {
        this.filterProductGroup = {
          label: item.label,
          id: item.id,
        };
        this.valueProductGroup = {
          label: item.label,
          id: item.id,
        };
      }
      // let value = this.dataChipsProduct.findIndex((items) => {
      //   return item.id === items.id;
      // });
      // if (value === -1) {
      //   this.rowChipsProduct =
      //     this.dataChipsProduct.length % 5 === 0
      //       ? Math.ceil(this.dataChipsProduct.length / 5) + 1
      //       : Math.ceil(this.dataChipsProduct.length / 5);
      //   this.dataChipsProduct.push({
      //     id: item.id,
      //     code_filter: item.code_filter,
      //     label: item.label,
      //     row: this.rowChipsProduct === 0 ? 1 : this.rowChipsProduct,
      //   });
      // }
      // this.countRowChipsProduct = Math.ceil(this.dataChipsProduct.length / 5);
    },
    expandTable() {
      this.checkExpand = true;
    },
    checkProduct(item, type) {
      this.$store.commit("pmmanage/loadingPage", true);
      let product_codes = [];
      let arrPriceType = item.sets[item.sets.length - 1].default_price;
      let dataArray = {};

      for (let i = 0; i < item.products.length; i++) {
        product_codes.push(item.products[i].code);
      }

      for (let j = 0; j < item.sets.length; j++) {
        for (let k = 0; k < item.sets[j].promotions.length; k++) {
          if (item.sets[j].promotions[k].type == "Free item") {
            for (let l = 0; l < item.sets[j].promotions[k].value.length; l++) {
              let check = product_codes.indexOf(
                item.sets[j].promotions[k].value[l].code
              );
              if (check < 0) {
                product_codes.push(item.sets[j].promotions[k].value[l].code);
              }
            }
          }
        }
      }

      let self = this;
      promotionService
        .checkProductInactive(product_codes)
        .then((rs) => {
          for (let i = 0; i < rs.inactive.length; i++) {
            let cyccode = rs.inactive[i].productlifecycle_code;
            let key_cyccode = rs.lifecycle.indexOf(cyccode);

            let index = item.products.findIndex(
              (item) => item.code === rs.inactive[i].code
            );
            if (index > -1) {
              item.products[index]["status"] = rs.inactive[i].status;

              if (key_cyccode < 0) {
                item.products[index]["status"] = "Inactive";
              }
              if (rs.inactive[i].balance !== undefined) {
                item.products[index]["stock"] = rs.inactive[i].balance;
              } else {
                item.products[index]["stock"] = "";
              }
            }

            // item.products.sort((a, b) => (a.code > b.code) ? 1 : -1)

            for (let j = 0; j < item.sets.length; j++) {
              for (let k = 0; k < item.sets[j].promotions.length; k++) {
                if (item.sets[j].promotions[k].type == "Free item") {
                  for (
                    let l = 0;
                    l < item.sets[j].promotions[k].value.length;
                    l++
                  ) {
                    let key = item.sets[j].promotions[k].value.findIndex(
                      (item) => item.code === rs.inactive[i].code
                    );
                    if (key > -1) {
                      item.sets[j].promotions[k].value[key]["status"] =
                        rs.inactive[i].status;

                      // let cyccode = item.sets[j].promotions[k].value[key][rs.inactive[i].productlifecycle_code];
                      // let key_cyccode = rs.lifecycle.indexOf(cyccode);
                      if (key_cyccode < 0) {
                        item.sets[j].promotions[k].value[key]["status"] =
                          "Inactive";
                      }
                    }
                  }

                  // item.sets[j].promotions[k].value.sort((a, b) => (a.code > b.code) ? 1 : -1)
                }
              }
            }
          }
          // self.$store.commit("pmmanage/setPromotions", item);

          if (!item.repeat) {
            item.repeat = false;
          }

          // console.log("item ==>", item);
          promotionService
            .updateRealPriceList({
              product_code: product_codes,
              price_type: arrPriceType,
            })
            .then(async (response) => {
              await promotionService.updatePromotionPrice(item).then((rs) => {
                dataArray = rs;
              });
              await promotionService
                .updateCostConv({ product_code: product_codes })
                .then((rscost) => {
                  // console.log("rscost ==>", rscost);
                  rscost.forEach(function (value, key) {
                    let index = dataArray.products.findIndex((v_data) => {
                      return value.iprod === v_data.code;
                    });
                    if (index > -1) {
                      dataArray.products[index]["cost_show"] = value.cost_conv
                        ? parseFloat(value.cost_conv)
                        : 0;
                    }
                  });
                });
              // console.log("dataArray ==>", dataArray);

              if (type == "page") {
                router.replace("/promotion/create");
                this.$store.commit("pmcreate/setStatusAction", "edit");
                this.$store.commit("pmcreate/setPromotion", dataArray);
                this.$store.commit("pmcreate/setStep", "step-1");
              } else if (type == "main-page") {
                router.replace("/promotion/create");
                this.$store.commit("pmcreate/setStatusAction", "create");
                this.$store.commit("pmcreate/setPromotion", dataArray);
                this.$store.commit("pmcreate/setStep", "step-1");
              } else {
                self.$store.commit("pmmanage/openApvDialog", dataArray);
              }

              this.$store.commit("pmmanage/loadingPage", false);
            });

          // if (type == "page") {
          //   router.replace("/promotion/create");
          //   this.$store.commit("pmcreate/setStatusAction", "edit");
          //   this.$store.commit("pmcreate/setPromotion", item);
          //   this.$store.commit("pmcreate/setStep", "step-1");
          // } else if (type == "main-page") {
          //   router.replace("/promotion/create");
          //   this.$store.commit("pmcreate/setStatusAction", "create");
          //   this.$store.commit("pmcreate/setPromotion", item);
          //   this.$store.commit("pmcreate/setStep", "step-1");
          // } else {
          //   self.$store.commit("pmmanage/openApvDialog", item);
          // }

          // this.$store.commit("pmmanage/loadingPage", false);
        })
        .catch();
    },
    convertDate(date) {
      return moment(new Date(date)).format("MMMM D, YYYY");
    },
    viewCampaign(id) {
      let datasearch = this.promotions.find((a) => a._id === id);
      this.$store.commit("pmmanage/openApvDialog", datasearch);
    },
    changeViewMonth(total_month) {
      this.viewMonth = parseInt(total_month);
    },
    customLabel({ id, label }) {
      return `${id} - ${label}`;
    },
    countString(string) {
      let num = 14;
      let str_val = "";
      if (string.id !== undefined) {
        str_val = string.id + " - " + string.name;
      } else {
        str_val = string.name;
      }

      let str = str_val.length;
      if (str > num) {
        this.titleChip = true;
        return str_val.substr(0, num) + "...";
      } else {
        this.titleChip = false;
        return str_val;
      }
    },
    clearAll(id, type) {
      if (type == "product") {
        this.filterProductGroup = [];
      } else if (type == "customer") {
        this.filterCustGroup = [];
      } else if (type == "usercreate") {
        this.filterUserCreate = [];
      }
    },
    deleteFilter(items, index) {
      this.filterChips.splice(index, 1);
      if (items.type == "product") {
        this.filterProductGroup = [];
        this.valueProductGroup = {};
      } else if (items.type == "customer") {
        this.filterCustGroup = [];
      } else if (items.type == "usercreate") {
        this.filterUserCreate = [];
      }
      this.searchPromotion("", "deleteFilter");
    },
    toggleHeight: function (condition) {
      let checkTypeOnClick;
      if (condition == "increase_sales") {
        this.increase_sales = !this.increase_sales;
        checkTypeOnClick = "IS";
      } else if (condition == "increase_outlet") {
        this.increase_outlet = !this.increase_outlet;
        checkTypeOnClick = "IO";
      } else if (condition == "new_product") {
        this.new_product = !this.new_product;
        checkTypeOnClick = "NP";
      } else if (condition == "compete") {
        this.compete = !this.compete;
        checkTypeOnClick = "CP";
      }
      this.checkChange = this.checkChange == false ? true : false;

      this.eventsData.forEach(function (value) {
        if (checkTypeOnClick == value.promotion_type) {
          value.checkShow = value.checkShow == false ? true : false;
        }
      });
    },
    deleteCondFilter(index) {
      this.filterChips.splice(index, 1);
    },
    showDialogFilterSearch() {
      this.tmpFilterProductGroup = JSON.parse(
        JSON.stringify(this.filterProductGroup)
      );
      this.tmpFilterCustGroup = JSON.parse(
        JSON.stringify(this.filterCustGroup)
      );
      this.tmpFilterUserCreate = JSON.parse(
        JSON.stringify(this.filterUserCreate)
      );

      // console.log("filterProductGroup ==>", this.filterProductGroup);
      this.showFilterDialog = true;
    },
    closeFilterDialog() {
      // console.log("- closeFilterDialog -");
      if (this.filterChips.length == 0) {
        this.filterProductGroup = [];
        this.filterCustGroup = [];
        this.filterUserCreate = [];
      } else {
        this.filterProductGroup = this.tmpFilterProductGroup;
        // console.log("this.tmpFilterProductGroup ==>", this.tmpFilterProductGroup);
        this.valueProductGroup =
          this.tmpFilterProductGroup.length === 0
            ? {}
            : this.tmpFilterProductGroup;
        this.filterCustGroup = this.tmpFilterCustGroup;
        this.filterUserCreate = this.tmpFilterUserCreate;
      }
      this.showFilterDialog = false;
    },
    addCondFilter() {
      this.showFilterDialog = false;
      this.filterChips = [];
      for (let i = 0; i < 3; i++) {
        let obj = {};
        if (i == 0) {
          if (this.filterProductGroup.id !== undefined) {
            obj = {
              name: this.filterProductGroup.label,
              id: this.filterProductGroup.id,
              type: "product",
            };
          }
        } else if (i == 1) {
          if (this.filterCustGroup._id !== undefined) {
            obj = {
              name: this.filterCustGroup.group_name,
              // id: this.filterCustGroup._id,
              type: "customer",
            };
          }
        } else if (i == 2) {
          if (this.filterUserCreate.code !== undefined) {
            obj = {
              name: this.filterUserCreate.name,
              // id: this.filterUserCreate.code,
              type: "usercreate",
            };
          }
        }

        if (obj.name !== undefined) {
          this.filterChips.push(obj);
        }
      }

      // console.log("- addCondFilter -", this.filterChips);
      // console.log("- filterProductGroup -", this.filterProductGroup);
      // console.log("- filterCustGroup -", this.filterCustGroup);
      this.searchPromotion("", "addCondFilter");
    },
    selectedCondition(index, promo, cond) {
      // let value = {
      //     row: promo
      // };

      let self = this;
      let user = Vue.$jwt.decode(localStorage.getItem("token"));
      let datas = {
        _id: promo._id,
        user_code: user.code,
      };

      if (cond.name == "Delete") {
        this.promotion_index = index;
        this.promotion = promo;
        this.dialog.content = `Are you sure to delete promotion "<b>${promo.promotion_code}</b>"`;
        this.dialog.active = true;
      } else if (cond.name == "Duplicate") {
        this.$store.commit("pmmanage/loadingPage", true);
        // this.checkProduct(promo, 'main-page');
        this.checkDupPromoCode(promo, promo.promotion_code);
        // const promotion = _.cloneDeep(promo);
        // delete promotion["_id"];
        // router.replace("/promotion/create");
        // this.$store.commit("pmcreate/setPromotion", promotion);
        // this.$store.commit("pmcreate/setStep", "step-1");
      } else if (cond.name == "Track") {
        // this.$store.dispatch("pmmanage/trackPromo", value);
        this.$store.commit("pmmanage/loadingPage", true);
        promotionService
          .Track(datas)
          .then(() => {
            self.$store.dispatch("pmmanage/getPromotions");
            self.refreshPage ? false : true;
            self.dContent =
              "You have tracking " + promo.promotion_code + " promotion.";
            self.showSnackbar = true;
          })
          .catch();
      } else if (cond.name == "Cancel Tracking") {
        this.$store.commit("pmmanage/loadingPage", true);
        promotionService
          .UnTrack(datas)
          .then(() => {
            self.$store.dispatch("pmmanage/getPromotions");
            self.refreshPage ? false : true;
            self.dContent =
              "You cancel tracking " + promo.promotion_code + " promotion.";
            self.showSnackbar = true;
          })
          .catch();
      } else if (cond.name == "Edit") {
        this.checkProduct(promo, "page");
        // router.replace("/promotion/create");
        // this.$store.commit("pmcreate/setStatusAction", "edit");
        // this.$store.commit("pmcreate/setPromotion", promo);
        // this.$store.commit("pmcreate/setStep", "step-1");
      } else if (cond.name == "Inactive Promo") {
        this.promoData = promo;
        this.dialogActivePromo = true;
      }
    },
    checkDupPromoCode(promo, promo_code, old_promo_id) {
      delete promo["approve_by"];
      let tmpPmCode = {};
      let value = promo_code;
      this.$store
        .dispatch("pmcreate/ck_promotion_code", {
          value,
        })
        .then(() => {
          let ck_promotion = this.$store.state["pmcreate"].ck_promotion;

          if (ck_promotion) {
            this.index_dup_code++;
            if (this.index_dup_code > 1) {
              let split_copy = promo_code.split(" Copy");
              self.copy_promo_code =
                split_copy[0] + " Copy " + this.index_dup_code;
            } else {
              self.copy_promo_code = value + " Copy " + this.index_dup_code;
            }
            this.checkDupPromoCode(
              promo,
              self.copy_promo_code,
              promo.promotion_id
            );
          } else {
            const promotion = _.cloneDeep(promo);
            let products = promotion.products;
            let datas = [];
            products.forEach((item, index) => {
              datas.push(item.code);
            });
            let new_datas = [];
            promotionService
              .getProductUpdate({ code: datas.join(",") })
              .then((rs) => {
                products.forEach((item, index) => {
                  if (rs[item.code] !== undefined) {
                    promotion.products[index].price = rs[item.code].price;
                    promotion.products[index].cost = rs[item.code].cost;
                    new_datas.push(promotion.products[index]);
                  } else {
                    delete promotion.products[index];
                  }
                });
                promotion.products = new_datas;

                let customer_datas = [];
                promotion.sets.forEach((item, index) => {
                  item.customers.forEach((customer, i) => {
                    customer_datas.push(customer.group_name);
                  });
                });
                let new_customer = [];
                promotionService
                  .getCustomerGroupUpdate({ code: customer_datas.join(",") })
                  .then((rs) => {
                    promotion.sets.forEach((item, index) => {
                      new_customer = [];
                      item.customers.forEach((customer, i) => {
                        if (rs[customer._id] !== undefined) {
                          new_customer.push(customer);
                        }
                      });
                      promotion.sets[index].customers = new_customer;
                    });

                    promotion.promotion_code = self.copy_promo_code;
                    promotion.promo_ref =
                      old_promo_id !== undefined ? old_promo_id : "";
                    delete promotion["_id"];
                    delete promotion["type_active"];

                    promotion.wf = [];

                    this.$store.commit("pmcreate/setPromotion", promotion);
                    this.checkProduct(promotion, "main-page");
                    // router.replace("/promotion/create");
                    // this.$store.commit("pmcreate/setStep", "step-1");
                    // this.$store.commit("pmmanage/loadingPage", false);

                    this.index_dup_code = 0;
                    return false;
                  });
              })
              .catch();
          }

          // this.checkProduct(promotionOpen);
        })
        .catch();
    },
    searchPromotion(type_search, type) {
      // let check_first_time = this.$store.getters["pmmanage/first_time"];
      // if (type !== undefined && type === "created" && check_first_time) {
      //   return;
      // }
      // console.log("- searchPromotion -");

      this.checkLoadDataServer =
        this.checkLoadDataServer === this.slcDuration ? false : true;

      // console.log("this.checkLoadDataServer ==>", this.checkLoadDataServer);

      this.$store.commit("pmmanage/loadingPage", true);
      let prodgroup = "";
      let custgroup = "";
      let createuser = "";
      if (this.filterProductGroup.id !== undefined) {
        prodgroup = this.filterProductGroup.id;
      }
      // console.log("this.filterCustGroup ==>", this.filterCustGroup);
      // if (this.filterCustGroup._id !== undefined) {
        // custgroup = this.filterCustGroup._id;
      if (this.filterCustGroup.group_code !== undefined) {
        custgroup = this.filterCustGroup.group_code;
      }
      if (this.filterUserCreate.code !== undefined) {
        createuser = this.filterUserCreate.code;
      }

      this.$store.dispatch("pmmanage/searchPromotion", {
        // type_search: type_search,
        type_search: this.checkLoadDataServer === true ? "duration" : "",
        status: this.slcStatus,
        strategies: this.slcStrategies,
        duration: this.slcDuration,
        keyword: this.iptSearch,
        custgroup: custgroup,
        prodgroup: prodgroup,
        createuser: createuser,
      });

      this.checkLoadDataServer = this.slcDuration;
      // this.$store.commit("pmmanage/firstTime", true);
    },
    randerStatus(item) {
      // Show only 2 status (draft and pending) > draft color gray > pending color yellow
      let status;
      if (item.type_active && item.type == "Draft") {
        status = "inactive";
      } else {
        status = item.type;
      }
      if (status) return "mktops-status-box " + status.toLowerCase();
    },
    randerCalendarView(condition) {
      if (condition.type == "increase_sales") {
        return "calendar-body-line green";
      } else if (condition.type == "increase_outlet") {
        return "calendar-body-line sky";
      } else if (condition.type == "new_product") {
        return "calendar-body-line blue";
      } else if (condition.type == "compete") {
        return "calendar-body-line violet";
      }
    },
    onConfirm() {
      this.$store
        .dispatch("pmmanage/deletePromotion", {
          promotion: this.promotion,
          index: this.promotion_index,
        })
        .then((rs) => {
          this.$store.dispatch("pmmanage/getPromotions");
        });
    },
    onCancel() {},
    onConfirmInAvtivePromo() {
      let user = Vue.$jwt.decode(localStorage.getItem("token"));
      let datas = {
        _id: this.promoData._id,
        promotion_code: this.promoData.promotion_code,
        u_code: user.code,
        type_active: true,
      };
      promotionService.updateTypeActive(datas);

      this.promoData.type_active = true;
      promotionService.updateStatusInactivePromo(this.promoData._id);
      router.replace("/promotion/create");
      this.$store.commit("pmcreate/setStatusAction", "edit");
      this.$store.commit("pmcreate/setPromotion", this.promoData);
      this.$store.commit("pmcreate/setStep", "step-1");
      this.promoData = [];
    },
  },
  directives: {
    infiniteScroll,
  },
};
</script>

<style lang="scss">
$font-Lato: Lato;
$font-Roboto: Roboto;
$color-primary: #3f51b5;
$color-grey: #a8a8a8;
$color-increase-sales: #52b6b0;
$color-increase-outlets: #5daaec;
$color-new-product: #527de5;
$color-compete: #9a67e3;
$color-green: #64a064;
$color-red: #f44336;

.mktops-maincontent-manage {
  padding: 20px;
  background-color: white;
  width: 100%;
  display: inline-flex;

  .head-title-page {
    width: 100%;
    font-family: Lato;
    font-size: 18px;
    color: #797979;
    font-weight: bold;
    margin: 5px;
  }

  .md-card {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
  }
  .left-panel {
    &.-display-100 {
      width: 100% !important;
    }

    width: 30%;
    min-width: 350px;
    .main-content {
      margin-top: 15px;

      .footer-table {
        display: block;
        text-align: center;
        margin-top: 10px;
        width: 99.6%;
        font-size: 14px;
        font-style: italic;
        font-weight: 300;
        color: #414141;
      }
    }
    .md-card.main-content {
      padding: 15px 20px;
    }
    .mktops-subheader-filter {
      margin-top: 5px;
    }

    // .triangle-expand {
    //   right: -8.6%;
    //   z-index: 2;
    //   position: absolute;
    //   width: 0;
    //   height: 0;
    //   border-top: 20px solid transparent;
    //   border-bottom: 20px solid transparent;
    //   border-left: 30px solid #f0f0f0;
    // }
    .triangle-expand {
      top: 1%;
      left: 99.9%;
      z-index: 2;
      position: absolute;
      width: 100px;
      height: 100px;
      overflow: hidden;
      // cursor: pointer;
      // box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);
    }
    .triangle-expand:after {
      content: "";
      position: absolute;
      width: 60px;
      height: 60px;
      background: #fff;
      transform: rotate(45deg);
      // top: 75px;
      right: 90px;
      cursor: pointer;
      // box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
      box-shadow: 1px 0 4px 0 rgba(0, 0, 0, 0.16);
    }
  }

  .right-panel {
    &.-displaynone {
      display: none;
    }

    position: sticky;
    margin: 0 0 0 16px;
    width: 69%;
    min-width: 560px;
    .row-right-panel {
      padding: 20px 20px 10px 30px !important;
    }

    // .noti-circle-red {
    //   width: 18px;
    //   height: 16px;
    //   padding-bottom: 18px;
    //   background-color: #B1424D;
    //   border-radius: 50px;
    //   // line-height: 36px;
    //   text-align: center;
    //   font-size: 10px;
    //   font-weight: bold;
    //   color: #ffffff;
    // }

    .noti-chip-red {
      padding-left: 5px;
      padding-right: 5px;
      border-radius: 50px;
      color: #ffffff;
      font-size: 10px;
      margin-left: 5px;
      background-color: #b1424d;
      max-height: 16px;
      line-height: 16px;
    }
  }
  .md-overlay {
    display: none;
  }

  .md-card.main-content {
    .mktops-select-box {
      height: 38px;

      .md-field.box > .md-input.md-select-value,
      .md-field.box > .md-menu.md-select {
        height: 28px;
      }

      .md-field.md-field.box {
        margin-top: unset;
        margin-bottom: unset;
        padding: unset;
      }

      .md-field:after,
      .md-field:before {
        left: unset;
      }

      .md-field.box .md-input.md-input.md-select-value,
      .md-field.box label {
        font-size: 12px;
        padding-left: 12px;
      }

      .md-field.box > .md-menu.md-select {
        overflow: unset;
        width: 120px;
      }

      .md-field.box .md-select {
        background-color: #efefef;
        border-radius: 3px;
      }
    }
    .filter-chips {
      margin-top: 5px;
      margin-bottom: 20px;

      .tab-chip {
        padding-left: 10px;
        padding-right: 8px;
        border-radius: 35px;
        color: white;
        font-size: 12px;
        padding-top: 5px;
        padding-bottom: 5px;

        &.-primary {
          // background-color: #3F51B5;
          background-color: #3f7fb5;
          margin-right: 5px;
        }

        &.-delete {
          // background-color: #11258c;
          background-color: #1c64a0;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 2px;
          padding-bottom: 2px;
          margin-left: 3px;
          cursor: pointer;

          .material-icons {
            font-size: 11px;
          }
        }
      }
    }
  }

  .group-mktops-label {
    padding-top: 3px;
    width: 23%;
  }

  .mktops-label-nodata {
    margin-top: 35%;
    text-align: center;
    font-family: $font-Roboto;
    font-size: 16px;
    color: #a8a8a8;
  }

  .group-mktops-label-btn {
    width: 77%;
    display: inherit;
    justify-content: flex-end;

    .mktops-label-btn {
      width: 90px;
      height: 26px;
      margin: 0 4px 0 0;
      border-radius: 4px;
      font-size: 10px;
      font-weight: bold;
      color: #ffffff;
      font-family: $font-Roboto;
      text-align: center;
      line-height: 26px;
      cursor: pointer;

      &.green {
        background-color: $color-increase-sales;
      }

      &.blue {
        background-color: $color-new-product;
      }

      &.sky {
        background-color: $color-increase-outlets;
      }

      &.violet {
        background-color: $color-compete;
      }

      &.gray {
        background-color: #efefef;
        color: #414141;
      }
    }
  }

  .mktops-circle-green {
    width: 32px;
    height: 32px;
    margin-top: 4px;
    background-color: $color-increase-sales;
    border-radius: 40px;
    line-height: 36px;
    text-align: center;
    font-size: 10px;
    color: #ffffff;
  }

  .mktops-subheader-text {
    width: 25%;
    font-size: 16px;
    font-family: $font-Lato;
    color: #414141;
    font-weight: bold;
    text-align: right;

    &.-filter {
      .md-ripple {
        width: 25px;
        height: 25px;
      }
    }

    .md-button:before {
      content: none;
    }
  }

  .mktops-subheader-filter {
    width: 75%;
    display: flex;
  }

  .mktops-status-box {
    font-family: $font-Roboto;
    font-size: 10px;
    width: 60px;
    max-width: 70px;
    text-align: center;
    height: 18px;
    // margin-top: 10px;
    margin-top: 1px;
    border-radius: 2px;
    color: #ffffff;
    font-weight: bold;

    &.draft {
      background-color: $color-grey;
    }

    &.pending {
      background-color: #fbc02d;
    }

    &.return {
      background-color: $color-red;
    }

    &.active {
      background-color: $color-green;
    }

    &.inactive {
      background-color: #2b9cfd;
    }
  }

  .mktops-promo-box {
    overflow-y: scroll;

    &.de-height {
      height: calc(100vh - 287px);
    }
    &.de3-height {
      height: calc(100vh - 316px);
    }

    &.cal-height {
      height: calc(100vh - 240px);
    }

    &.de-height-expand {
      // height: calc(100vh - 204px);
      height: calc(100vh - 254px);
    }

    &.cal-height-expand {
      // height: calc(100vh - 163px);
      height: calc(100vh - 208px);
    }

    #table-manage-promotion {
      .row-bg-gray:hover {
        border-radius: 4px;
        background: rgba(236, 236, 235, 1);
      }

      #divHeadList {
        width: 99.3%;
        display: -webkit-inline-box;
        font-size: 13px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 13px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }
        }
      }

      #divBodyList {
        &.de-height-expand {
          height: calc(100vh - 260px);
        }

        &.cal-height-expand {
          height: calc(100vmin - 211px);
        }
        width: 100%;
        display: block;
        overflow-y: scroll;
        font-size: 13px;

        > div {
          width: 100%;
          // height: 45px;
          display: -webkit-inline-box;
          padding-top: 5px;
          padding-bottom: 5px;

          div {
            // border: 1px solid pink;
            padding-left: 5px;
            padding-right: 5px;
            height: 36px;
            // display: table;
            display: grid;
            text-align: left !important;

            span {
              vertical-align: middle;
              display: table-cell;
              width: 100%;

              &.-title {
                width: 100%;
                color: rgba(0, 0, 0, 0.38);
              }
            }

            &.-text-right {
              text-align: right;
            }

            &.-text-center {
              text-align: center;
            }

            &.nowrap-title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              .-font-kanit {
                font-size: 14px;
                font-family: kanit !important;
              }
            }
          }
        }

        .circle-green {
          padding: 0px;
          width: 36px;
          height: 36px;
          background-color: #52b6b0;
          border-radius: 50px;
          margin: auto;
        }

        .mktops-promo-list-status {
          .mktops-status-box {
            width: 60px;
          }
          .md-icon-button {
            width: 30px;
            min-width: 30px;
            height: 30px;
            margin-top: 3px;
          }
          .menu-morevert {
            .md-ripple {
              display: flex !important;
            }
          }
        }

        &::-webkit-scrollbar {
          height: 7px;
          width: 8px;
        }
      }
    }

    .md-icon-button {
      width: 22px;
      min-width: 22px;
      height: 22px;
      margin-top: 5px;
      margin-left: 5px;

      .md-ripple {
        padding: 0px;
        padding-top: 7px;
      }
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 8px;
      background-color: #ffffff;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ffffff;
      border-radius: 4px;
    }

    .mktops-promo-list-name {
      font-family: $font-Lato, Light;
      margin-left: 10px;
      width: 58%;
      font-size: 12px;
      cursor: pointer;

      .title-list {
        color: rgba(0, 0, 0, 0.38);
      }

      .subtitle-list {
        color: rgba(0, 0, 0, 0.7);
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 10px;
        color: #414141;
        font-weight: bold;
        margin-top: 5px;
      }
    }

    .mktops-promo-list-status {
      width: 30%;
      display: flex;
      justify-content: flex-end;
    }

    .mktops-promo-box-list {
      margin-bottom: 10px;
      width: 100%;
      display: flex;
    }
  }

  .md-search-box {
    margin: 15px 0;
    padding-top: unset;
    width: 100%;
    border-radius: 3px;
    min-height: 36px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
      0 1px 1px -2px rgba(0, 0, 0, 0);

    .md-icon.material-icons {
      margin-left: 15px;
      padding-top: 3px;
      color: rgba(0, 0, 0, 0.54);
    }

    .md-input {
      height: 36px;
    }

    &.md-field > .md-icon:after,
    &.md-field:after,
    &.md-field:before {
      content: none;
    }
  }
  .ml-40 {
    margin-left: 40px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .ml-20 {
    margin-left: 20px;
  }
  .calendar-view {
    width: 100%;
    .schedule {
      overflow-y: scroll;
      overflow-x: hidden;
      background-color: #f8f8f8;
      width: 100%;
      position: relative;
      // padding-right: 8px;
      .task-ground {
        width: 100%;
        ul {
          list-style-type: none;
          padding-left: 0px;
          margin-top: 0px;
          margin-bottom: 0px;
          text-align: center;
        }
      }
      .task-list {
        font-family: Lato;
        font-size: 14px;
        float: left;
        box-sizing: border-box;
        border-left: 1px solid #eaeaea;
        background: #f8f8f8;
        color: #727272;
        .calendar-circle-gray {
          width: 24px;
          height: 24px;
          background-color: #efefef;
          border-radius: 40px;
          line-height: 24px;
          text-align: center;
          font-size: 11px;
          font-weight: bold;
          color: $color-grey;
        }
        .task-list-item {
          text-align: left;
          position: absolute;
          background-color: #577f92;
          font-family: Lato;
          font-size: 10px;
          cursor: pointer;
          padding-left: 10px;
          line-height: 16px;
          border-radius: 4px;
          label {
            text-align: left;
            padding: 0;
            color: #ffffff;
          }
        }
      }
      & .font14 {
        font-size: 14px;
        display: flex;
        justify-content: center;
        .calendar-circle-gray {
          margin: -1px 0 0 15px;
        }
      }
      & .font12 {
        font-size: 12px;
        display: flex;
        justify-content: center;
        .calendar-circle-gray {
          margin: -1px 0 0 5px;
        }
      }
      & .small-action {
        width: 5%;
      }
      & .small-content {
        font-weight: bold;
        width: 30%;
      }
      & .medium-action {
        width: 5%;
      }
      & .medium-content {
        width: 15%;
        font-weight: bold;
      }
      & .large-action {
        width: 5%;
      }
      & .large-content {
        width: 7.5%;
        font-weight: bold;
      }
      & :first-child {
        border: none;
      }
    }
    .schedule-head {
      .md-button {
        margin-top: 10px;
      }
      .font12,
      .font14 {
        height: 38px;
        margin-top: 20px;
      }
    }
    .schedule-content {
      height: calc(100vh - 204px);
    }
    .schedule-head,
    .schedule-content {
      &::-webkit-scrollbar {
        height: 7px;
        width: 8px;
        background: #f7f7f7;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #f7f7f7;
        border-radius: 5px;
      }
    }
  }
  .calendar-view:hover {
    .schedule-content {
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.12);
      }
    }
  }
  .mktops-promo-box:hover {
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.12);
    }
  }

  .md-icon-button {
    &.-disable .md-icon {
      display: none;
    }
  }

  .bg-backdrop-promotion {
    background: rgba(0, 0, 0, 0.35);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 15;
    top: 0;
    left: 0;
  }
}

.filter-dialog {
  width: 35%;
  transform: unset !important;
  top: 28% !important;
  left: 32.5% !important;

  .md-dialog-title.md-title {
    font-size: 18px;
    margin-bottom: 5px;
    padding: 24px 30px 0;
  }

  .layout-dialog {
    padding: 10px 25px 5px 25px;

    .filter-items {
      padding-left: 3px;

      input {
        width: 100%;
        margin: 7px;
        padding-left: 5px;
        padding-right: 5px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 5px;
        background: #fff;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .search-box-dropdown {
      min-height: 36px;
      margin: 5px;

      .md-search-box {
        padding-top: 0px;
        min-height: 36px;

        // &.md-focused {
        //   min-height: 36px;
        // }

        i {
          margin-left: 10px;
        }
      }
    }
  }

  .multiselect {
    .z-index-top {
      z-index: 10;
    }

    margin: 5px 5px 12px 5px;
    .multiselect__single,
    .multiselect__input {
      font-size: 14px;

      div {
        display: flex;
        width: 100%;
        .-delete {
          width: 5%;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      font-size: 14px;
      z-index: 10;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }

  .-action {
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    justify-content: flex-end;

    .-cancel .md-button-content {
      color: #727272;
    }

    .-filter {
      color: #3f51b5;
    }
  }
}

.promotion-calendar-card {
  height: calc(100vh - 78px);

  .md-card-content {
    //height: '100%';//calc(100vh - 230px);
    padding: 0px;
  }

  .md-card-header {
    // height: 50px;
    // padding-top: 10px !important;
    padding: 20px 20px 10px 30px !important;
    .title {
      //font-size: 12px;
      margin-top: 10px;
      font-style: Lato, Bold;
      font-weight: 500;
      color: #414141;
    }
  }

  .schdule-contain {
    .Table {
      height: calc(100vh - 200px);
    }

    .toDay {
      height: calc(100vh - 220px);
    }

    .event {
      height: 25px !important;
    }
  }
}

.promo-content-noti {
  width: 420px;
  max-width: 420px !important;
  height: 351px;
  max-height: 351px !important;
  left: unset !important;
  right: 34px !important;
  background-color: #efefef !important;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.16) !important;

  .md-menu-content-container {
    overflow: unset;
  }

  .title {
    text-align: center;
    color: #727272;
    font-size: 16px;
    font-weight: bold;
    height: 40px;
    padding-top: 12px;
  }

  .detais {
    height: 300px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      height: 7px;
      width: 6px;
    }
  }

  div {
    width: 100%;
    font-family: lato;
  }

  ul {
    border-radius: 5px;
    background-color: #efefef !important;
  }

  .item-card {
    height: 70px;
    margin: 5px 5px 8px 5px;
    cursor: pointer;

    div {
      background-color: #ffffff;
    }

    .nowrap-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .noti-date {
    text-align: right;
    color: #a8a8a8;
    font-size: 12px;
    margin-top: 2px;
  }
}
</style>
